import Skeleton from "react-loading-skeleton/lib";
import {Table} from "react-bootstrap";
import React from "react";
import {connect} from "react-redux";
import i18n from "../i18nextInitiator";
import {compose} from "redux";
import TrackerHoc from "../new-ui/components/Tracker/TrackerHoc";
import {formatPrice} from "../actions/actionCreators";

/**
 * This is the funciton to access translations.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');

const mapStateToProps = state => ({...state});

const mapDispatchToProps = dispatch => ({});

const InvoiceTable = (props) => {
    const {
        invoice: {
            bill = {}
        }
    } = props;
    return (
        <Table responsive borderless striped={!!props.invoice.bill} className='text-center'>
            <thead>

            <tr>
                <th>{t('invoice.services')}</th>
                <th>{t('count')}</th>
                <th>{t('price')}</th>
            </tr>
            </thead>
            <tbody>

            {props.invoice.bill ? props.invoice.bill.details.map(bill => {
                    return (
                        <tr>
                            <td> {bill.title || <Skeleton/>} </td>
                            <td> {bill.count || ""} </td>
                            <td> {bill.price ? formatPrice(bill.price) : ""} </td>
                        </tr>
                    );
                })
                :
                <>

                    <tr>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                </>
            }

            {/*{props.order.bill && props.order.bill.order.workers.detail.map(bill=>{*/}
            {/*    return(*/}
            {/*        <tr>*/}
            {/*            <td> {bill.title || <Skeleton/>} </td>*/}
            {/*            <td> {bill.number || <Skeleton/>} </td>*/}
            {/*            <td> {*/}
            {/*                (bill.price * Math.pow(10, -1))*/}
            {/*                    .toString().replace(/\B(?=(\d{3})+(?!\d))/g , ",")*/}
            {/*                || <Skeleton/>} </td>*/}
            {/*        </tr>*/}
            {/*    );})*/}
            {/*}*/}

            {/*{props.order.bill && props.order.bill.order.expensive_tools.detail.map(bill=>{*/}
            {/*    return(*/}
            {/*        <tr>*/}
            {/*            <td> {bill.title || <Skeleton/>} </td>*/}
            {/*            <td> {bill.number || <Skeleton/>} </td>*/}
            {/*            <td> {*/}
            {/*                (bill.price * Math.pow(10, -1))*/}
            {/*                    .toString().replace(/\B(?=(\d{3})+(?!\d))/g , ",")*/}
            {/*                || <Skeleton/>} </td>*/}

            {/*        </tr>*/}
            {/*    );})*/}
            {/*}*/}

            {/*{(props.order.bill) && props.order.bill.order.extra_description.map(desc=>{*/}
            {/*    return(*/}
            {/*        <tr>*/}
            {/*            <td/>*/}
            {/*            <td/>*/}
            {/*            <td> {desc || <Skeleton/>} </td>*/}
            {/*            /!*<td> {desc || <Skeleton/>} </td>*!/*/}
            {/*            /!*<td> {*!/*/}
            {/*            /!*    (bill.price * Math.pow(10, -1))*!/*/}
            {/*            /!*        .toString().replace(/\B(?=(\d{3})+(?!\d))/g , ",")*!/*/}
            {/*            /!*    || <Skeleton/>} </td>*!/*/}

            {/*        </tr>*/}
            {/*    );})*/}
            {/*}*/}


            <tr>
                <td>{t("invoice.pre.final-price")}</td>
                <td/>
                <td className='total'>
                    {formatPrice(bill.price) || <Skeleton/>}
                </td>
            </tr>

            </tbody>
        </Table>
    );
}

export default compose(TrackerHoc, connect(mapStateToProps, mapDispatchToProps))(InvoiceTable);